const parseSubmitEvent = (e: any) => {
    e.preventDefault();
    var result = {} as any;
    if (e.target?.length > 0) {
        for (let i = 0; i < e.target.length; i++) {
            if (e.target[i].name && e.target[i].type !== "submit") {
                result[e.target[i].name] = e.target[i].type === "checkbox" ? e.target[i].checked : e.target[i].value;
            }
        }
    }
    return result;
};

const parseChangeEvent = (e: any) => {
    var result = {} as any;
    if (e.target.name && e.target.type !== "submit") {
        result[e.target.name] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    }
    return result;
};

export { parseSubmitEvent, parseChangeEvent };
